/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';

import { parseServerDateTime, formatDisplayDate, formatDisplayTime } from '@/util/MomentUtils';

import NotesView from '../views/NotesView';

export default async function loadNotes(data) {
  const notes = await data.getNotesService(data.objectId);

  _.each(notes, (note) => {
    note.createdDate = formatDisplayDate(parseServerDateTime(note.createdOn));
    note.createdTime = formatDisplayTime(parseServerDateTime(note.createdOn));
  });

  //Orders
  const orderIds = [];
  const orderNotes = _.filter(notes, (note) => {
    if (!_.includes(orderIds, note.objectId) && note.objectTypeId === 'ORDER') {
      orderIds.push(note.objectId);
    }
    return note.objectTypeId === 'ORDER';
  });

  //Order Packages
  const orderPackageNotes = _.filter(notes, (note) => {
    return note.objectTypeId === 'ORDER_PACKAGE';
  });
  const isOrderPackage = !!data.metadata.orderPackageID;

  //Customers
  const customerNotes = _.filter(notes, (note) => {
    return note.objectTypeId === 'CUSTOMER';
  });
  const isCustomer = !!data.metadata.customerId;

  return new NotesView({
    submitNoteService: data.submitNoteService,
    model: new Backbone.Model({
      editable: data.editable,
      notes,
      objectId: data.objectId,
      objectTypeId: data.objectTypeId,
      metadata: data.metadata,
      submitNoteAttachmentService: data.submitNoteAttachmentService,
      pathToFileId: data.pathToFileId,
      orderIds,
      orderNotes,
      orderPackageNotes,
      customerNotes,
      isCustomer,
      isOrderPackage,
      objectType: data.objectType
    })
  });
}
